import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import type { EntitySummary } from "../../shared/api";

export function SearchBar() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState<EntitySummary[]>([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const boxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (q.trim().length < 1) {
      setResults([]);
      return;
    }
    const t = setTimeout(() => {
      api.search(q).then((r) => { setResults(r.items); setOpen(true); }).catch(() => setResults([]));
    }, 160);
    return () => clearTimeout(t);
  }, [q]);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (boxRef.current && !boxRef.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  return (
    <div className="search" ref={boxRef}>
      <span className="ico" aria-hidden>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.7" />
          <path d="m11 11 3.5 3.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        </svg>
      </span>
      <input
        className="input"
        placeholder="Search…"
        aria-label="Search tokens and companies"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        onFocus={() => results.length && setOpen(true)}
      />
      {open && results.length > 0 && (
        <div className="search-results">
          {results.map((r) => (
            <a
              key={r.id}
              onClick={() => { setOpen(false); setQ(""); navigate(`/${r.type}/${r.slug}`); }}
              className="u-3b6a3a6"
            >
              <strong className="u-c821f2f">{r.name}</strong>
              {r.symbol && <span className="sym mono">{r.symbol}</span>}
              <span className="sym u-6d00061">{r.type}</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
